import { Injectable } from '@angular/core';
import { Config } from '../config/config';
import { RestDataService } from './rest-data.service';

@Injectable()
export class CommonUtilityService {

  constructor(
    private restService: RestDataService,
    private config: Config
  ) { }


  insertCrossDomainStory(storyId, arrayList){
    // this.restService.http_post(this.config.get('product').baseUrl
    // + "/api/cms/story/crossdomain/"+ storyId ,'', result => {

    //   let index = arrayList.indexOf(storyId);
    //   if(index !== -1){
    //     arrayList[index] = result.id;
    //   }
    // });
    // return arrayList;
  }

}
